import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  LinkStyled,
  ButtonModalStyled,
  LogoStyled,
  PinItemStyled,
  TextStyled,
  PinContainerStyled,
  LineTextStyled,
  LeftBlock,
  RightBlock,
  AlignText,
  StepNumber,
  StepContainer,
  StepText,
  StepTextContainer,
  QRCode,
  PinLoginInfoContainer,
  LoginOptionContainer
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { generatePin, loginPin, generateToken } from "../../services/pinLoginService";
import { routes } from "../../routes";
import { autologin } from "../../services/authenticationService";
import { getLoginRedirectionData } from "../../services/navigationService";
// import { getFlavor } from "../../services/flavor";
import Logo from "../../components/Logo";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const loginFocusPath = "loginVoucherModal_passThru";
const TO_BE_MIGRATED = "TO_BE_MIGRATED";
const MIGRATED = "MIGRATED";

class PinLoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: "",
      isLoading: true,
      timer: null
    };
    this.timer = null;
    this.onBack = this.onBack.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
  }

  async getPin() {
    const pinResponse = await generatePin();
    this.setState({ pin: pinResponse.pin });
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
    (async () => {
      await this.getPin().then(() => {
        this.setState({ isLoading: false });
      });

      let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);
      // this.timer = setInterval(async () => {
      window.pinCheckTimer = setInterval(async () => {
        if (window?.location?.pathname !== "/pin") {
          clearInterval(window.pinCheckTimer);
          return;
        }
        try {
          const { stateActions, history } = this.props;
          const loginPinResponse = await loginPin({ pin: this.state.pin });
          if (loginPinResponse.errorCode === 4009) {
            await this.getPin();
          } else if (loginPinResponse.webToken && loginPinResponse.webToken !== "false") {
            // clearInterval(this.state.timer);
            clearInterval(window.pinCheckTimer);
            localStorage.setItem("userJWT", loginPinResponse.webToken);
            const data = await autologin();
            this.props.applicationState.userName = data.username;
            stateActions.userLoggedIn(data);
            if (data.settings.migration_status && data.settings.migration_status === TO_BE_MIGRATED) {
              redirectTo.call(this, routes.migratingtostarzplay, historyMethods.REPLACE);
            } else if (data.settings.migration_status && data.settings.migration_status === MIGRATED) {
              redirectTo.call(this, routes.gotostarzplay, historyMethods.REPLACE);
            } else {
              redirectPath === "/login" || redirectPath === "/player"
                ? redirectTo.call(this, routes.home, historyMethods.REPLACE)
                : history[navigationMode](redirectPath);
            }
          } else {
            if (
              (!loginPinResponse.webToken || loginPinResponse.webToken === "false") &&
              loginPinResponse.token &&
              loginPinResponse.uid
            ) {
              /** if webtoken missed from loginPin call, we will hit the same login endpoints with  username as uid and password as spx token with flag verifyJwtOnly to generate the JWT token.
                    And using this token for the subsequent user call and billing calls to make the user login. 
                 */
              clearInterval(this.timer);
              const data = { username: loginPinResponse.uid, password: loginPinResponse.token, verifyJwtOnly: true };
              const loginTokenResponse = await generateToken(data);
              if (loginTokenResponse && loginTokenResponse.globalUserId) {
                stateActions.userLoggedIn(loginTokenResponse);
                // if (voucherData && voucherData.autoRedeem) {
                //  let path = await checkForUmanagedOrNonChangeableMop.call(this);
                // if (path) {
                //  redirectTo.call(this, path, null, historyMethods.REPLACE);
                // }
                //  } else {
                redirectPath === "/login" || redirectPath === "/player"
                  ? redirectTo.call(this, routes.home, historyMethods.REPLACE)
                  : history[navigationMode](redirectPath);
                //  }
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }, 5000);
    })();
    this.props.setFocus(loginFocusPath);
  }

  componentWillUnmount() {
    // if (this.timer) {
    // clearInterval(this.timer);
    if (window.pinCheckTimer) {
      clearInterval(window.pinCheckTimer);
    }
  }

  enterHandler(eventAction, path, locationData) {
    // trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  onBack() {
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  render() {
    const {
      applicationState: { userLocale }
    } = this.props;
    return (
      <LandingPageStyled>
        {this.state.isLoading && <Loading overlay />}
        <PinLoginInfoContainer>
          <LeftBlock userLocale={userLocale}>
            <LandingContainerStyled>
              <TextStyled rank="1" text={i18n.get("pages.pinLogin.heading")} size="large" />
              <StepContainer userLocale={userLocale}>
                <StepNumber>1</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step1")} size="medium" />
                  {/* <LinkStyled rank="2">{i18n.get("pages.pinLogin.url")}</LinkStyled> */}
                </StepTextContainer>
              </StepContainer>
              <StepContainer userLocale={userLocale}>
                <StepNumber>2</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step2")} size="medium" />
                </StepTextContainer>
              </StepContainer>
              <StepContainer userLocale={userLocale}>
                <StepNumber>3</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step3")} size="medium" />
                  <PinContainerStyled userLocale={userLocale}>
                    {this.state.pin?.split("").map((v, i) => (
                      <PinItemStyled key={`pin-${i}-${v}`}>{v}</PinItemStyled>
                    ))}
                  </PinContainerStyled>
                </StepTextContainer>
              </StepContainer>
            </LandingContainerStyled>
          </LeftBlock>
          <RightBlock userLocale={userLocale}>
            <AlignText>
              <LogoStyled>
                <Logo height={"8.055vh"} width={"15.47vw"} />
              </LogoStyled>
            </AlignText>
            <QRCode
              src={`https://ev-cdn-lb.twist-tv.com/prd-peg-data/default/twist/images/qrcodes/linktv-${userLocale}.png`}
              alt="QR-Code"
            />
          </RightBlock>
        </PinLoginInfoContainer>
        {/* <LoginOptionContainer style={{ display: "flex", flexDirection: "column" }}>
          <LineTextStyled>{i18n.get("pages.pinLogin.or")}</LineTextStyled>

          <ButtonModalFocus
            label={i18n.get("pages.pinLogin.loginButton").toUpperCase()}
            focusPath={loginFocusPath}
            onEnterPress={() => this.enterHandler("login_user_selects_passwordlogin", routes.login)}
            onMouseUp={() => this.enterHandler("login_user_selects_passwordlogin", routes.login)}
            size="medium"
            dataSnUp={""}
            dataSnDown={""}
            dataSnLeft={""}
            dataSnRight={""}
            type="primary"
          />
        </LoginOptionContainer> */}
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(PinLoginPage));
